exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".Maps-module__wrapper___1mBpU{border-radius:35px;overflow:hidden;height:100%;width:100%;height:calc(100dvh - 200px)}@media (max-width:768px){.Maps-module__wrapper___1mBpU{height:55dvh}}", ""]);

// exports
exports.locals = {
	"wrapper": "Maps-module__wrapper___1mBpU"
};